import { CustomerCartItemPrices, AnonCartItemPrices } from "../types/CartPrice";
import { PriceAndPromotionInfo } from "../types/PriceAndPromotionInfo";

import * as _ from "lodash";

// also works for customer cart
export function convertFromAnonCartItem(
    itemPrice: AnonCartItemPrices | CustomerCartItemPrices | undefined | null
): PriceAndPromotionInfo | undefined | null {
    if (!itemPrice) {
        return null;
    }
    // When translating from new cart to old cart, the following translation rules help to understand
    // what is going on:
    // - piece = single
    // - unit = bundle
    return {
        priceHiddenReason: null,
        valid: true,
        currency: _.get(itemPrice, "bundle.article.net.currency"),
        strikeThroughNet: _.get(itemPrice, "bundle.strikeThrough.net.amount"),
        strikeThroughGross: _.get(itemPrice, "bundle.strikeThrough.gross.amount"),
        unitNet: _.get(itemPrice, "bundle.article.net.amount"),
        unitGross: _.get(itemPrice, "bundle.article.gross.amount"),
        unitNetWithTaxes: _.get(
            itemPrice,
            "bundle.articleWithTaxes.net.amount",
            _.get(itemPrice, "bundle.article.net.amount")
        ),
        unitGrossWithTaxes: _.get(
            itemPrice,
            "bundle.articleWithTaxes.gross.amount",
            _.get(itemPrice, "bundle.article.gross.amount")
        ),
        pieceNet: _.get(itemPrice, "single.sum.net.amount"),
        pieceGross: _.get(itemPrice, "single.sum.gross.amount"),
        // pieceNet / pieceGross don't seem have 'without taxes' versions in the
        // Evaluate price data, so we're keeping them as is for now
        depositNet: _.get(itemPrice, "bundle.empties.net.amount"),
        depositGross: _.get(itemPrice, "bundle.empties.net.amount"),
        kgNet: _.get(itemPrice, "position.perKg.net.amount") || _.get(itemPrice, "single.perKg.net.amount"),
        kgGross: _.get(itemPrice, "position.perKg.gross.amount") || _.get(itemPrice, "single.perKg.gross.amount"),
        positionNet: _.get(itemPrice, "position.article.net.amount"),
        positionGross: _.get(itemPrice, "position.article.gross.amount"),
        positionNetWithTaxes: _.get(
            itemPrice,
            "position.articleWithTaxes.net.amount",
            _.get(itemPrice, "position.article.net.amount")
        ),
        positionGrossWithTaxes: _.get(
            itemPrice,
            "position.articleWithTaxes.gross.amount",
            _.get(itemPrice, "position.article.gross.amount")
        ),
        isManualPrice: isManualPrice(itemPrice),
        isCipBbp: isCipBbp(itemPrice),
        isCip: isCip(itemPrice),
        isPromotion: isPromotion(itemPrice),
        isDnr: isDnr(itemPrice),
        isDnrActive: isDnrActive(itemPrice),
        appliedDnrIds: getAppliedDnrIds(itemPrice),
        appliedDnrs: getAppliedDnrs(itemPrice),
        promotionSavings: _.get(itemPrice, "position.discount.amount")
    };
}

function isDnr(priceInfo: any) {
    return !!priceInfo.summaryDnr;
}

function isDnrActive(priceInfo: any) {
    return isAdjustmentsApplied(priceInfo, "DNR");
}

function getAppliedDnrIds(priceInfo: any) {
    if (priceInfo && priceInfo.appliedDnrs) {
        return _.map(priceInfo.appliedDnrs, (dnr) => dnr.number.toString());
    }
    return [];
}

function getAppliedDnrs(priceInfo: any) {
    if (priceInfo && priceInfo.appliedDnrs) {
        return priceInfo.appliedDnrs;
    }
    return [];
}

function isAdjustmentsApplied(priceInfo: any, adjustment: string) {
    if (priceInfo && priceInfo.appliedAdjustments && priceInfo.appliedAdjustments.includes(adjustment)) {
        return true;
    }
    return false;
}

function isCip(priceInfo: any) {
    return isAdjustmentsApplied(priceInfo, "CIP");
}

// customer individual price breaks best price, always taken
function isCipBbp(priceInfo: any) {
    return isAdjustmentsApplied(priceInfo, "CIPBBP");
}

function isPromotion(priceInfo: any) {
    return isAdjustmentsApplied(priceInfo, "PROMOTION");
}

function isManualPrice(priceInfo: any) {
    return isAdjustmentsApplied(priceInfo, "MANUAL");
}
